import React, { useState } from 'react';

//components
import IngredientForm from '../components/forms/IngredientForm';

//page for creating a new ingredient
function CreateIngredient() {
    return (
        <div>
            <h1>Create Ingredient</h1>
            <IngredientForm />
        </div>
    );

}

export default CreateIngredient;